var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[(_vm.setting?.type === 'SettingBool')?_c('SettingBoolWidget',{attrs:{"setting":_vm.setting,"readOnly":_vm.readOnly}}):(_vm.setting?.type === 'SettingChoice')?_c('SettingChoiceWidget',{attrs:{"setting":_vm.setting,"readOnly":_vm.readOnly}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }